import sdl from '@jds/react-generated-sdl/JDSFeedbackBlock';
import type { JDSFeedbackBlockProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFeedbackBlockProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'l',
    state = 'none',
    alignment = 'center',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, state, alignment, ...rest },
    'JDSFeedbackBlock',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FeedbackBlock = withLogic(
  Component
) as React.FC<JDSFeedbackBlockProps> & { slotName?: string };

FeedbackBlock.displayName = 'FeedbackBlock';
FeedbackBlock.slotName = 'jds_feedback_block';

export { FeedbackBlock, type JDSFeedbackBlockProps };
